export default function (value: number): number {
  if (!value) {
    return 0;
  }
  return Math.round(value);
}
